// Vendor
import axios from 'axios';
//Types
import { API_LOCALE_PLACEMENT, } from '../types/plugin/api';
import { REQUEST_TOKEN } from '../types/auth';
import { ACCESS_TOKEN_KEY, IMPERSONATING_KEY } from '../globals/auth';
// Stores
import { useApiSettings } from '../stores/api/module';
import { useAuthentication } from '../stores/auth/module';
function localeSettings(locale) {
    const _defaultKey = 'locale';
    if (!locale) {
        return null;
    }
    if (locale === true) {
        return {
            key: _defaultKey,
            placement: API_LOCALE_PLACEMENT.PARAM,
        };
    }
    return {
        key: locale.key || _defaultKey,
        placement: locale.placement || API_LOCALE_PLACEMENT.PARAM,
    };
}
function createAPI(options) {
    // Options
    const { baseURL, impersonateHeader = 'x-switch-user', locale, onSessionExpired, tokenType = 'Bearer', } = options || {};
    const _locale = localeSettings(locale);
    const api = axios.create({
        baseURL,
    });
    /**
     * Interceptors
     */
    api.interceptors.request.use(async (config) => {
        // Composable
        const auth = useAuthentication();
        const apiSettings = useApiSettings();
        const token = auth[ACCESS_TOKEN_KEY];
        if ([REQUEST_TOKEN.SECURE, REQUEST_TOKEN.OPTIONAL].indexOf((config === null || config === void 0 ? void 0 : config.tokenLevel) || 0) !==
            -1 &&
            token) {
            config.headers.Authorization = `${tokenType} ${token}`;
            if (auth.isAuthenticated && auth[IMPERSONATING_KEY]) {
                config.headers[impersonateHeader] = auth[IMPERSONATING_KEY];
            }
        }
        if (apiSettings.locale && _locale) {
            if (_locale.placement === API_LOCALE_PLACEMENT.HEADER) {
                config.headers[_locale.key] = apiSettings.locale;
            }
            if (_locale.placement === API_LOCALE_PLACEMENT.PARAM) {
                config.params = Object.assign(Object.assign({}, config.params), { [_locale.key]: apiSettings.locale });
            }
        }
        return config;
    });
    api.interceptors.response.use(async (response) => {
        return response;
    }, async (error) => {
        var _a, _b, _c, _d;
        // Composable
        const auth = useAuthentication();
        const _impersonatedUserHeaders = __TEST__ && ((_a = error.config) === null || _a === void 0 ? void 0 : _a.headers[impersonateHeader])
            ? {
                impersonatedUser: (_b = error.config) === null || _b === void 0 ? void 0 : _b.headers[impersonateHeader],
            }
            : {};
        if (auth.isAuthenticated &&
            (error.request.status === 401 || __TEST__) &&
            ((_d = (_c = error.config) === null || _c === void 0 ? void 0 : _c.headers) === null || _d === void 0 ? void 0 : _d.Authorization)) {
            const response = await auth.refreshAuthentication().catch(async (data) => {
                await auth.removeSession();
                if (onSessionExpired) {
                    onSessionExpired();
                }
                return Promise.reject(Object.assign(Object.assign({}, data), _impersonatedUserHeaders));
            });
            if (response === null || response === void 0 ? void 0 : response.token) {
                error.config.headers.Authorization = `${tokenType} ${response.token}`;
                return api.request(error.config);
            }
        }
        return Promise.reject(Object.assign(Object.assign({}, error.response), _impersonatedUserHeaders));
    });
    return api;
}
const useAPI = (options) => (_context) => {
    _context.store.$api = options.api;
    _context.store.$endpoints = options.endpoints;
};
export { createAPI, useAPI, useApiSettings, API_LOCALE_PLACEMENT };
//# sourceMappingURL=api.js.map